module.exports = __webpack_public_path__ + "img/Logo.04e9f1d7.svg";